import { render } from "./Index.vue?vue&type=template&id=2e8f5661"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Pages/Booking/Failure/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e8f5661"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e8f5661', __exports__)) {
    api.reload('2e8f5661', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=2e8f5661", () => {
    api.rerender('2e8f5661', render)
  })

}


export default __exports__